import { PHONE, mediaQueries } from 'base/constants/mediaQueries';

export const isMobileMedia = () => {
  return window.matchMedia(mediaQueries[PHONE]).matches;
};
